import { Locale, type LocalizedString } from "@core/schema/Locale.js";

export const partnerSearchParamLocalized: LocalizedString = {
	[Locale.cs]: "partner",
};
